import PropTypes from 'prop-types';
import './techSession.scss';
import Box from '@mui/material/Box';
import SessionTaken from '../../../Assets/images/svg/dar_session.svg';
import SessionHours from '../../../Assets/images/svg/dar_hours_clock.svg';
import SessionHosts from '../../../Assets/images/svg/dar_host.svg';
import SessionSheduled from '../../../Assets/images/svg/dar_total_blogs.svg';
import CurrentYearSession from '../../../Assets/images/svg/dar_session_calender.svg';
import ButtonComponent from '../../../Components/Button/button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import { fetchCurrentPerformanceCycle } from './techSessionCardsUtils';

const MetricsCards = ({ techSessionData, hasAccess, btnOnclick, selectedDate }) => {
  const { snackbarOpen } = useSnackbar();
  const [performanceCycleData, setPerformanceCycleData] = useState([]);
  const [cycleStartDate, setCycleStartDate] = useState('');
  const [cycleEndDate, setCycleEndDate] = useState('');

  const getMonthName = (date) => {
    return date.toLocaleString('default', { month: 'long' });
  };

  const getYearName = (date) => {
    return date.toLocaleString('default', { year: 'numeric' });
  };

  useEffect(() => {
    fetchCurrentPerformanceCycle(snackbarOpen).then(setPerformanceCycleData);
  }, []);

  useEffect(() => {
    if (performanceCycleData?.length != 0){
      setCycleStartDate(performanceCycleData?.startDate);
      setCycleEndDate(performanceCycleData?.endDate);
    }
  }, [performanceCycleData]);

  const techMetricData = [
    {
      id: 1,
      heading: 'Sessions taken',
      value: techSessionData.totalSessionTaken,
      image: SessionTaken,
    },
    {
      id: 2,
      heading: 'No. of hours',
      value: techSessionData.totalHours,
      image: SessionHours,
    },
    {
      id: 3,
      heading: 'No. of hosts',
      value: techSessionData.totalHosts,
      image: SessionHosts,
    },
    {
      id: 4,
      heading: `Total sessions -  ${getMonthName(selectedDate)}`,
      value: techSessionData.totalUpcomingSession,
      image: SessionSheduled,
    },
    {
      id: 5,
      heading: `Sessions taken - ${getYearName(selectedDate)}`,
      value: techSessionData.sessionTakenCurrentYear,
      image: CurrentYearSession,
    },
  ];

  return (
    <div>
      <div className="tech-session-metrics-container">
        {techMetricData.map((deal) => (
          <Tooltip
            title={`Performance period: ${cycleStartDate} - ${cycleEndDate}`}
            classes={{ tooltip: 'tech-session-card-tooltip' }}
            disableHoverListener={deal.id === 4 || deal.id === 5}
            key={deal.id}
          >
            <Tooltip>
              <Box key={`box-${deal.id}`} className="tech-session-metrics-box">
                {deal.image && (
                  <img
                    src={deal.image}
                    className="tech-session-metrics-image"
                    alt={deal.heading}
                  />
                )}
                <div className="tech-session-metrics-inner-box">
                  <div className="tech-session-metrics-heading">{deal.heading}</div>
                  <div className="tech-session-metrics-value">{deal.value}</div>
                </div>
              </Box>
            </Tooltip>
          </Tooltip>
        ))}
        <div className="create-session-button">
          <ButtonComponent
            disabled={!hasAccess('create')}
            id="add-session-btn"
            label={'Create session'}
            onClick={btnOnclick}
            variant="contained"
            startIcon={<AddIcon />}
            btnCss={
              !hasAccess('create')
                ? 'add-session-btn-disabled'
                : 'add-session-btn'
            }
          />
        </div>
      </div>
    </div>
  );
};

export default MetricsCards;

MetricsCards.propTypes = {
  techSessionData: PropTypes.object.isRequired,
  hasAccess: PropTypes.func,
  btnOnclick: PropTypes.func.isRequired,
  selectedDate: PropTypes.instanceOf(Date).isRequired,
};
